import {
    FILE_DATA_FORM_ADD_MODEL_EDIT,
    FILE_DATA_FORM_ADD_SKU_EDIT,
    FILE_DATA_FORM_DELETE,
    FILE_DATA_FORM_REMOVE_MODEL_EDIT,
    FILE_DATA_FORM_REMOVE_SKU_EDIT,
    FILE_DATA_FORM_TOGGLE_ACTIVE,
    PRODUCT_ASSETS_FETCHING,
    PRODUCT_ASSETS_FETCHING_FAILURE,
    PRODUCT_ASSETS_FETCHING_SUCCESS,
    UPDATE_FILE_DATA_FORM_EDIT,
} from '../actions/types'

const INITIAL_STATE = {
    items: {},
    loading: false,
    page: 1,
    pageSize: 10,
    total: 0,
    query: '',
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRODUCT_ASSETS_FETCHING:
            return {
                ...state,
                loading: true,
            }

        case PRODUCT_ASSETS_FETCHING_SUCCESS:
            return {
                ...state,
                loading: false,
                items: prepareItems(action.payload),
                page: action.page,
                pageSize: action.pageSize,
                query: action.query,
                total: action.total,
            }

        case PRODUCT_ASSETS_FETCHING_FAILURE:
            return {
                ...state,
                loading: false,
            }

        case UPDATE_FILE_DATA_FORM_EDIT:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        ...action.payload,
                    },
                },
            }

        case FILE_DATA_FORM_ADD_SKU_EDIT:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        skus: [...state.items[action.id].skus, action.payload],
                    },
                },
            }

        case FILE_DATA_FORM_REMOVE_SKU_EDIT:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        skus: state.items[action.id].skus.filter(
                            sku => sku !== action.payload
                        ),
                    },
                },
            }

        case FILE_DATA_FORM_ADD_MODEL_EDIT:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        models: [
                            ...state.items[action.id].models,
                            action.payload,
                        ],
                    },
                },
            }

        case FILE_DATA_FORM_REMOVE_MODEL_EDIT:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        models: state.items[action.id].models.filter(
                            model => model !== action.payload
                        ),
                    },
                },
            }

        case FILE_DATA_FORM_TOGGLE_ACTIVE:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        active: !state.items[action.id].active,
                    },
                },
            }

        case FILE_DATA_FORM_DELETE:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.id]: {
                        ...state.items[action.id],
                        active: false,
                    },
                },
            }

        default:
            return state
    }
}

const prepareItems = items => {
    const result = {}
    items.forEach(item => {
        result[item.id] = item
    })
    return result
}

export default reducer
